document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.desktop___media_collection')) {
    console.log('.desktop___media_collection nahi mila — code skip');
    return;
  }

  const mediaQuery = window.matchMedia('(min-width: 768px)');

  function runHeightLogic() {
    if (!mediaQuery.matches) return;

    const productCard = document.querySelector('product-card[data-index="1"]');
    const customElements = document.querySelectorAll('.desktop___media_collection');

    if (!productCard || customElements.length === 0) return;

    const height = productCard.getBoundingClientRect().height;

    customElements.forEach(el => {
      // el.style.height = (height * 2) + 'px';
      el.style.height = ((height * 2) - 44) + 'px';
    });
  }

  // Initial run
  runHeightLogic();

  // Resize / zoom handler
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runHeightLogic, 110);
  });

  // Media query change
  mediaQuery.addEventListener('change', (e) => {
    const customElements = document.querySelectorAll('.desktop___media_collection');

    if (e.matches) {
      runHeightLogic();
    } else {
      customElements.forEach(el => el.style.height = '');
    }
  });

});



class ProductCardScroller {
  constructor(card) {
    this.card = card;
    this.container = card.querySelector('.product-card__media');
    this.images = this.container.querySelectorAll('.product-card__image');
    this.currentIndex = 0;

    // Arrows
    this.arrowWrapper = card.querySelector('.product_card-arrow');
    this.leftArrow = card.querySelector('.left-arrow');
    this.rightArrow = card.querySelector('.right-arrow');

    if (!this.container || this.images.length === 0) return;


    // Arrow click events
    if (this.leftArrow) {
      this.leftArrow.addEventListener('click', () => this.prev());
    }

    if (this.rightArrow) {
      this.rightArrow.addEventListener('click', () => this.next());
    }
  }

  scrollToIndex(index) {
    this.container.scrollTo({
      left: this.images[index].offsetLeft,
      behavior: 'smooth'
    });
  }

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.scrollToIndex(this.currentIndex);
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToIndex(this.currentIndex);
    }
  }
}

// Initialize for all product cards
document.querySelectorAll('product-card').forEach(card => {
  if (card.querySelector('.product-card__media')) {
    new ProductCardScroller(card);
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".localization-toggle");
  const popover = document.querySelector(".popover");

  if (!btn || !popover) return;

  // initial state
  popover.style.display = "none";

  btn.addEventListener("click", () => {
    const isOpen = popover.style.display === "block";

    popover.style.display = isOpen ? "none" : "block";
    btn.setAttribute("aria-expanded", String(!isOpen));
  });
});
